<div class="content content-md" [attr.data-selected-client-id]="currentClientId">
  <div class="scroll-content" >
    <div id="content-list" class="list list-md" >
      @for (client of clients; track client) {
        <button
          class="item item-block item-md" text-wrap=""
          (click)="setSelectedClient(client.ClientID)"
          [attr.data-client-id]="client.ClientID"
          >
          <div class="item-inner">
            <div class="input-wrapper width-100">
              <div class="list-label label label-md width-100 padding-right-5 padding-left-5">
                <div class="ellipses-label">{{client.ClientShortName}}</div>
              </div>
              <div class="arrow-container">
                <div class="arrow-wrapper radio-wrapper">
                  <input type="radio"
                    value="{{client.ClientID}}"
                    [ngModel]="currentClientId"
                    class="radio"
                    />
                </div>
              </div>
            </div>
            <div class="button-effect"></div>
          </div>
        </button>
      }
    </div>
  </div>
